 class Raf {
  constructor() {
    this.running = false
    this.rafId = null
    this._fns = []
 
    this.startWithStats()
  }

  _update = (delta) => {
    let i = this._fns.length
    while (i--) {
      let fn = this._fns[i]
      if (fn) this._fns[i](delta)
    }
    this.rafId = window.requestAnimationFrame(this._update)
  }

  _updateWithStats = (delta) => { 
    let i = this._fns.length
    while (i--) {
      let fn = this._fns[i]
      if (fn) this._fns[i](delta)
    } 
    this.rafId = window.requestAnimationFrame(this._updateWithStats)
  }

  start = () => {
    if (this.running) return
    this.running = true
    this.rafId = window.requestAnimationFrame(this._update)
  }

  startWithStats = () => {
    if (this.running) return
    this.running = true
    this.rafId = window.requestAnimationFrame(this._updateWithStats)
  }

  stop = () => {
    window.cancelAnimationFrame(this.rafId)
    this.running = false
  }

  add = (fn) => {
    if (typeof fn === 'function') {
      if (this._fns.indexOf(fn) >= 0) return false
      this._fns.push(fn)
      return true
    } else {
      return false
    }
  }

  remove = (fn) => {
    const idx = this._fns.indexOf(fn)
    if (idx >= 0) this._fns.splice(idx, 1)
  }
}

const raf = new Raf()
window.Raf = raf
export default raf
